import React from 'react';
//import './pwa'
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import AppRouter from './Router';
import './index.css';

console.log('main.tsx loaded');
if (typeof document !== 'undefined') {
  console.log('Document exists, looking for root element...');
  const container = document.getElementById('root');
  console.log('Root container:', container);
  if (container) {
    console.log('Creating root...');
    const root = createRoot(container);
    console.log('Rendering App...');
    root.render(/* ... */);
  }
}

// Only attempt to render in the browser
if (typeof document !== 'undefined') {
  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <HelmetProvider>
          <AppRouter />
        </HelmetProvider>
      </React.StrictMode>
    );
  }
}